import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Trash: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#trash-16)">
      <path
        d="M1.21667 3.68359H14.7833"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3875 1.2168H6.6125C6.36717 1.2168 6.1319 1.31425 5.95843 1.48772C5.78495 1.66119 5.6875 1.89647 5.6875 2.1418V3.68346H10.3125V2.1418C10.3125 1.89647 10.215 1.66119 10.0416 1.48772C9.8681 1.31425 9.63283 1.2168 9.3875 1.2168Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.61252 11.5459V6.9209"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.38751 11.5459V6.9209"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2303 13.9326C12.2132 14.1643 12.1089 14.381 11.9384 14.5389C11.7679 14.6968 11.5439 14.7842 11.3115 14.7836H4.68851C4.45613 14.7842 4.23214 14.6968 4.06165 14.5389C3.89116 14.381 3.78683 14.1643 3.76967 13.9326L2.91251 3.68359H13.0875L12.2303 13.9326Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="trash-16">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
